module.exports = __webpack_public_path__ + "static/logo-5d31744c6cd415e483b2b2666e54a4fa.png";